import { render, staticRenderFns } from "./DataAccessATSchool.vue?vue&type=template&id=7b35b99c&scoped=true"
import script from "./DataAccessATSchool.vue?vue&type=script&lang=js"
export * from "./DataAccessATSchool.vue?vue&type=script&lang=js"
import style0 from "./DataAccessATSchool.vue?vue&type=style&index=0&id=7b35b99c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b35b99c",
  null
  
)

export default component.exports